import React from "react";
import Backdrop from "@/components/base/backdrop";
import PageLayout from "@/components/base/page-layout";
import withErrorBoundary from "@/components/hoc/with-error-boundary";
import Orders from "@/components/orders";
import useQueryBrands from "@/hooks/queries/useQueryBrands";
import useQueryOrders from "@/hooks/queries/useQueryOrders";
import { Params, useParams } from "react-router-dom";
import type { Brand } from "@/types/brand";

const BrandPage: React.FC = () => {
  const { bid } = useParams<Params>();
  const { data: brands } = useQueryBrands();
  const { data: orders, isFetching } = useQueryOrders(bid);

  const brand = brands?.find((brand: Brand) => brand.id === bid);

  if (!brand || !orders) {
    return <Backdrop loading={isFetching} />;
  }

  return (
    <PageLayout title={brand.title.en} showCalendar={true}>
      <Orders data={orders} />
    </PageLayout>
  );
};

export default withErrorBoundary({ component: "BrandPage" })(BrandPage);
